import React from "react";
import { Puff } from "react-loader-spinner";

const SpinnerLoader = (props) => {
  return (
    <Puff
      height="50"
      width="50"
      radisu={1}
      color={"#0065c9"}
      ariaLabel="puff-loading"
      wrapperStyle={{
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
        marginTop: 100,
        marginBottom: 100,
      }}
      wrapperClass=""
      visible={props.visible}
    />
  );
};

export default SpinnerLoader;
